import { render } from "./CuratedList.vue?vue&type=template&id=522e4f55&scoped=true"
import script from "./CuratedList.vue?vue&type=script&lang=js"
export * from "./CuratedList.vue?vue&type=script&lang=js"

import "./CuratedList.vue?vue&type=style&index=0&id=522e4f55&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-522e4f55"]])

export default __exports__